import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("byrd_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/login") {
        localStorage.removeItem("byrd_token");
        localStorage.removeItem("byrd_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function photoUrl(photoId) {
  if (!photoId) return null;
  return `${API_BASE}/photos/${photoId}`;
}

export default api;
